<template>
  <div class="modals">
    <b-modal id="alerta" ref="alerta" title="Alerta">
      <b-alert show variant="warning">Warning Alert</b-alert>
    </b-modal>
    <b-modal id="sucesso" ref="sucesso" title="Sucesso">
      <b-alert show variant="success">Success Alert</b-alert>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'modals',
};
</script>
